import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {Button, Col, Form, FormGroup, FormText, Input, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, InputGroup, InputGroupAddon} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {Validacao} from "../../comum/components/Validacao";
import Select from "react-select";
import {createSelectOptions, formatTelefone} from "../../../utils/formatar";
import NumberFormat from "react-number-format";

@inject("store")
@observer
export class ContatoForm extends Component {

    static propTypes = {
        contatoGlobo: PropTypes.object,
        setNome: PropTypes.func,
        setTelefone: PropTypes.func,
        setEmail: PropTypes.func
    };

    constructor(props) {
        super(props);
    }

    render() {

        const contatoGlobo = this.props.contatoGlobo;
        return (
            <div>
                <h4>Contato</h4>
                <Row>
                    <Col xs={12} md={4} lg={4}>
                        <FormGroup>
                            <Label>Contato Globo</Label>
                            <Input type="text" value={contatoGlobo ? contatoGlobo.nome : ""} readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={4} lg={4}>
                        <FormGroup>
                            <Label>Telefone de contato</Label>
                            <NumberFormat className="form-control" format={(value) => formatTelefone(value)} maxLength={15} value={contatoGlobo ? contatoGlobo.telefone : ""} onChange={(event, values) => this.props.setTelefone(values.value)} />
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={4} lg={4}>
                        <FormGroup>
                            <Label>E-mail de contato</Label>
                            <div>
                                <Input type="text" value={contatoGlobo ? contatoGlobo.email : ""} readOnly/>
                            </div>
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        )
    }
}